import {
  Component, AfterViewChecked,
  ChangeDetectorRef, OnChanges, SimpleChanges,
  OnDestroy, Directive, EventEmitter, Input, Output, QueryList, ViewChildren, ViewChild, OnInit, ViewEncapsulation, HostListener
} from '@angular/core';
import { environment } from '../../../environments/environment';
import { IBanData, InvoicesService } from '../../services/invoices.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BillingPortalProps } from '../../models/BillingPortalProps';
import { SessionStorageService } from '../../services/session-storage.service';
import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ReusableErrorComponent } from '../../shared/popup/reusable-error-component/reusable-error.component';
import { BansStorageService } from '../../services/bans-storage.service';
import { IndexedDbService } from '../../services/indexeddb.service';
import { IInvoice } from '../../models/invoices/Invoices';
import { MobileDeviceService } from '../../services/mobile-view-checker.service';

@Component({
  selector: 'ngbd-modal-content',
  template: `
      <div class="modal-body text-center ac-success-msg" [style.display]="success?success:'none'">
      <i class="las la-check-circle fs-48"></i>
      <p><svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M31 0C13.95 0 0 13.95 0 31C0 48.05 13.95 62 31 62C48.05 62 62 48.05 62 31C62 13.95 48.05 0 31 0ZM24.8 46.5L9.3 31L13.671 26.629L24.8 37.727L48.329 14.198L52.7 18.6L24.8 46.5Z" fill="#168007"/>
    </svg></p>
      <h2>Download Successfully!</h2>
        <p class="ac-modelpara">{{name}}</p>
      </div>
      <div class="modal-body text-center ac-error-msg" [style.display]="error?error:'none'">
      <i class="las la-times-circle fs-48"></i>
      <p><svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36 0C55.908 0 72 16.092 72 36C72 55.908 55.908 72 36 72C16.092 72 0 55.908 0 36C0 16.092 16.092 0 36 0ZM48.924 18L36 30.924L23.076 18L18 23.076L30.924 36L18 48.924L23.076 54L36 41.076L48.924 54L54 48.924L41.076 36L54 23.076L48.924 18Z" fill="#D30000"/>
    </svg></p>
      <h2>Download Error!</h2>
        <p class="ac-modelpara" style="margin-top: 30px;">{{name}}</p>
      </div>
      <div class="modal-footer ac-modelfooter">
        <button type="button" class="btn btn-outline-dark ac-btn-outline-primary ac-butncancel display-block text-center" (click)="closed()">Close</button>
      </div>
    `
})

export class NgbdModalContent {
  @Input() name: any;
  @Input() status: any;
  @Input() success: any = "none";
  @Input() error: any = "none";
  @Input() className: any;
  isPayClicked: boolean = false;
  supportLanguages = ['en'];
  constructor(public activeModal: NgbActiveModal,
    public translate: TranslateService) {

    this.translate.addLangs(this.supportLanguages);
    this.translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    var lang = browserLang?.match(/en|fr/) ? browserLang : 'en';
    translate.use(lang);
  }
  closed() {
    this.activeModal.close();
    //parent.location = location.ancestorOrigins.item(0)?.toString()+"/invoices" || "/invoices";
  }

  @HostListener('document:click', ['$event'])
  clickout(event:any) {
    this.closed()
  }
}
export type SortColumn = keyof IInvoice | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()'
  }
})
export class NgbdSortableHeader {

  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}
@Component({
  selector: 'app-invoices-list',
  templateUrl: './invoices-list.component.html',
  styleUrls: ['./invoices-list.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom, // or ViewEncapsulation.none
  //encapsulation:ViewEncapsulation.Emulated,


})
export class InvoicesListComponent implements OnInit, AfterViewChecked, OnDestroy, OnChanges {
  @Input() token: string = 'initial token!';
  // @Input() customerID: string = environment.customerID;
  @Input() isAgent: boolean = false;
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  @ViewChild(ReusableErrorComponent) errorPopup!: ReusableErrorComponent;

  customerIDs: Array<string> = [];
  eventHandler: any;
  banflag: boolean = false;
  invoices: Array<IInvoice> = new Array();
  Allinvoices: Array<IInvoice> = new Array();
  selectedInvoices: Array<IInvoice> = new Array();
  pendingAmountToPay: number = 0;
  totalEditedAmount: number = 0;
  currency: any;
  payStatus: string[] = [];
  checkedInvoiceList: any;
  isMasterSel: boolean;
  checkSingleItem: boolean = false;
  iNumber!: string;
  banCAs = new Map<string, Array<string>>();
  closeResult: string = "";
  bans: any = [];
  ban: string = "";
  showLoader: boolean = false;
  showbtn!: boolean;
  paymentType: string = "fullAmount";
  invoicesSearch: string  = '';
  isLoading = false;
  currentPage = 1;
  itemsPerPage = environment.itemsPerPage;

  toggleLoading = () => this.isLoading = !this.isLoading;

  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  banResponse : any;
  bansForTSA : any = [];
  unSupportedBanInvoices: boolean = false;
  instructionTextForPopup : string = "";
  isInvoicesAPICall: boolean = false;
  isAllInvoicesLoaded: boolean = true;
  invoiceFilterValue: string= 'All';
  isViewInvoiceEnabled: boolean = environment.ViewInvoiceEnableFlag;
  permissions: String[] = environment.billingProps.permissions;
  permissionMessage: String  = "You do not have permission to view invoice. Please connect with your system administrator.";
  @ViewChild('permissionStatus') permissionStatus: any;
  isMakePaymentEnabled: boolean = environment.MakePyamentEnableFlag;
  paymentMessage: String  = "You do not have permission to make the payment. Please connect with your system administrator";
  @ViewChild('paymentStatus') paymentStatus: any;
  isAllInvoicesPaid: boolean = true;
  invoiceFilterDD: any = []
  filterSectiontoggle: boolean = false;
  isMobileView: boolean = false;

  constructor(private router: Router,
    private ref: ChangeDetectorRef,
    private invoicesService: InvoicesService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private storageService : SessionStorageService,
    private http: HttpClient,
    private bansService: BansStorageService,
    private indexedDbService: IndexedDbService,
    private MobileDeviceService: MobileDeviceService
  ) {
    let aToken = localStorage.getItem('azuretoken');
    this.token = aToken != null ? JSON.parse(aToken) : '';
    this.isMasterSel = false;
    this.customers=  this.customerIds.join(',');
  }

  ngAfterViewChecked(): void {
    const customEvent = new CustomEvent('InvoicesLoaded', {});
    window.dispatchEvent(customEvent);
  }

  ngOnDestroy(): void {
    console.log('Destroying invoices!');
    window.removeEventListener('sendToken', (l: any) => {
      console.log('Removing Listener!');
    });
  }

  customerIds: String[] = environment.billingProps.customerIds;
  customers: string='';

  async ngOnInit() {
    this.getBans()
    this.uncheckAllInvoices()
    this.BillingPortalProps = environment.billingProps;
    this.customerIDs = this.BillingPortalProps ? this.BillingPortalProps.customerIds : [environment.customerID];
    this.customerIDs.push(environment.customerID);
    this.customers = this.customerIds.join(',');
    this.bansService.banApiStaus.subscribe((apiStatus: any) => {
      if (apiStatus=='FetchedBansByCustomerId'){
        this.customersData(this.customers);
      }
    })
    this.MobileDeviceService.isMobileView$.subscribe((isMobile) => {
      this.isMobileView = isMobile;
    });
  }

  customerData: any = {
    openBal: '',
    nextInvoiceDue: '',
    balDue: ''
  };
  formattedNextInvoiceDue: string = '';
  totalInvoice:any;
  sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  customersData(customerIDs: string): void {
    this.invoicesService.getTotalInvoices(customerIDs).subscribe({
      next: (data) => {
        this.customerData = data;
        console.log(this.customerData);
        this.formattedNextInvoiceDue = this.customerData.nextInvoiceDue && this.formatDate(this.customerData.nextInvoiceDue);
      },
      error: (err) => {
        console.error("data not loading");
      }
    });
  }

  formatDate(dateStr: string) {
    const year = parseInt(dateStr.substring(0, 4), 10);
    const month = parseInt(dateStr.substring(4, 6), 10) - 1;
    const day = parseInt(dateStr.substring(6, 8), 10);
    const date = new Date(year, month, day);

    const formattedDay = String(date.getDate()).padStart(2, '0');
    const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
    const formattedYear = date.getFullYear();

    return `${formattedMonth}/${formattedDay}/${formattedYear}`;
}

  getBans() {
    this.bansService.bans.subscribe((bans: any) => {
      this.bansService.bansTSA.subscribe((bansTSA: any) => {
        if (bansTSA) {
          this.bansForTSA = bansTSA;
        }
      })
      this.bansService.bansApiResponse.subscribe((bansResponse: any) => {
        if (bansResponse) {
          this.banResponse = bansResponse;
        }
      })
      if (bans) {
        this.banCAs = bans;
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let banCA = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_CAs_Dropdown")));
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];
        let selectedBANCA = banCA ? banCA : firstBAN[1];
        var sledBan = this.banResponse && this.banResponse.find((x: { bancust: string; })  => x.bancust ==  this.ban)||{zzachclass_bus:""};
        this.getInvoices(this.ban, selectedBANCA,sledBan.zzachclass_bus == 'SLED'? true : false);
      }
      else{
        this.bansService.banFlag.subscribe(
          (isPresent: boolean) => {
            if(!isPresent){
              this.unSupportedBanInvoices = true;
              this.invoices = [];
              this.Allinvoices = [];
            }
          }
        );
      }
    })
  }

  onSort({ column, direction }: SortEvent) {

    console.log("onsort fun", this.invoices)
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction === '' || column === '') {
      this.invoices = this.Allinvoices.slice(0, this.invoices.length);
      console.log("if", this.invoices)

    } else {
      console.log("direction invoice:", this.invoices)

      this.Allinvoices = [...this.Allinvoices].sort((a, b) => {
        if(column.toLocaleLowerCase().includes("date")){
          if(direction === 'asc')
            return new Date(b[column]).getTime() - new Date(a[column]).getTime();
          else
            return new Date(a[column]).getTime() - new Date(b[column]).getTime();
        }else{
          const res = compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }

      });

      this.invoices = this.Allinvoices.slice(0, this.invoices.length);
    }
  }


  selectedBan() {
    if (this.ban != "BAN") {
      const selectedBan = this.banCAs.get(this.ban) || [""];
      var sledBan =  this.banResponse.find((x: { bancust: string; }) => x.bancust ==  this.ban)||{zzachclass_bus:""};
      this.getInvoices(this.ban, selectedBan,sledBan.zzachclass_bus == 'SLED'?true:false);
    }
  }

  onSendTokenEvent(event: any) {
    console.log('Receiveed Token is - ', event);
    this.token = event?.detail;
    window.removeEventListener('sendToken', this.eventHandler, true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(JSON.stringify(changes));
    if (changes['token'].currentValue != changes['token'].previousValue) {
      const curr = changes['token'].currentValue;
      console.log(curr);
    }
  }

  /* Check Uncheck all checkbox on main check box click*/
  checkUncheckAll() {
    for (var i = 0; i < this.getInvoicesList.length; i++) {
      this.getInvoicesList[i].isSelected = this.isMasterSel && !this.getInvoicesList[i].isPaid;
      if (this.isMasterSel) {
        if (!this.getInvoicesList[i].isPaid) {
          this.pendingAmountToPay += +this.getInvoicesList[i].pending_amount;
          this.currency = this.getInvoicesList[i].currency;
          this.payStatus.push(this.getInvoicesList[i].status);
        }
      } else {
        this.pendingAmountToPay = 0;
        this.currency = "";
        this.payStatus.push("");
      }
    }
    this.getCheckedItemList();
  }

  /* Uncheck all checkbox */
  uncheckAllInvoices() {
    for (var i = 0; i < this.getInvoicesList.length; i++) {
      this.getInvoicesList[i].isSelected = false;
    }
    this.selectedInvoices = []
  }

  isAllSelected() {
    this.isMasterSel = this.getInvoicesList.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.checkedInvoiceList = [];

    for (var i = 0; i < this.getInvoicesList.length; i++) {
      if (this.getInvoicesList[i].isSelected)
        this.checkedInvoiceList.push(this.getInvoicesList[i]);
      else
        this.checkSingleItem = false
    }

    if (this.checkSingleItem) {
      this.isMasterSel = true;
    }
    this.selectedInvoices = this.checkedInvoiceList;
  }


  async getInvoices(banNo: string, contractAcc: string[],isSledCustomer:any) {
    this.banflag = false;
    this.invoices = new Array();
    let filteredBAN = this.bansForTSA.filter((element: any) => { return (element.bancust == banNo)});
    if(filteredBAN.length && !filteredBAN[0].isSamevkTyp && environment.tsaErrorPopupVisibility){
      this.instructionTextForPopup = "There is some issue with your account, please contact support team.";
      this.showErrorScreen();
      return
    }
    this.unSupportedBanInvoices = false
    let vktyp = filteredBAN[0] && filteredBAN[0].vktyp[0];
    console.log("inside getinvoice" + this.invoices.length);
    contractAcc = filteredBAN.length && filteredBAN[0].isTSA ? filteredBAN[0].contractacc : contractAcc;
    const cachedInvoices = await this.indexedDbService.getInvoices(banNo);
    if (cachedInvoices && cachedInvoices.length) {
      this.Allinvoices = cachedInvoices;
      this.invoices = this.Allinvoices.slice(0, this.itemsPerPage);
      this.populateInvoiceFilterDropdown();
      let isLoadMoreClicked = await this.indexedDbService.getLoadInvoiceCheck(banNo);      
      if(isLoadMoreClicked){
        this.loadMoreInvoices();
      }
      else{
        this.resetLoadMoreButton();
      }
    }
    else{
      this.invoicesService
        .getInvoices(banNo, contractAcc.toString(), '', filteredBAN[0].isTSA) //environment.vktypForTSA.includes(vktyp)
        .subscribe(async (res: any) => {
          res.forEach((element: any) => {
            let statusColor = '';
            const invoiceStatus = new String(element.status);
            if (invoiceStatus.toUpperCase() == 'NOT PAID') statusColor = '#ffd6d6';
            else if (invoiceStatus.toUpperCase() == 'PAID') statusColor = '#d6f8d2';
            else if (invoiceStatus.toUpperCase() == 'PARTIALLY PAID') statusColor = '#fedcc3';

            var bill = {
              invoice_id: element.invoiceId,
              date: element.date,
              caContract: element.caContract,
              amount: element.amount,
              currency: element.currency,
              status: element.status,
              statusColor: statusColor,
              status_class: 'btn-success ac-inv-paid',
              isSelected: false,
              dueDate: element.dueDate,
              pending_amount: element.pendingAmount,
              editedAmountToPay: parseFloat(element.pendingAmount).toFixed(2),
              invoiceReversalDocumentID: element.invoiceReversalDocumentID,
              invoiceReversedDocumentID: element.invoiceReversedDocumentID,
              bpNo: element.businessPartner,
              StreetName: element.streetName && element.streetName.toLowerCase(),
              Country: element.country,
              CityName: element.cityName && element.cityName.toLowerCase(),
              zipCode: element.zipCode,
              region: element.region,
              businessPartnerName: element.businessPartnerName,
              isPaid: element.status.toUpperCase() === 'PAID' || element.status.toUpperCase() === 'REVERSED' || element.pendingAmount <= 0,
              isSledCustomer : isSledCustomer
            };
            if (element.invoiceReversedDocumentID == '000000000000') {
              if (this.invoices.findIndex((item) => item.invoice_id === bill.invoice_id) < 0) {
                this.invoices.push(bill);
              }
            }
          });
          this.invoices = this.invoices.sort((a: any, b: any) => {
            return <any>new Date(b.dueDate).getTime() - <any>new Date(a.dueDate).getTime();
          });
          // this.invoices = this.invoices.sort((a: any, b: any) => b.invoice_id - a.invoice_id);
          this.Allinvoices = this.invoices;
          this.invoices = this.Allinvoices.slice(0, this.itemsPerPage);
          this.populateInvoiceFilterDropdown();
          await this.indexedDbService.storeInvoices(banNo, this.Allinvoices);
          this.banflag = true;
          this.resetLoadMoreButton();
        });
    }
  }

  populateInvoiceFilterDropdown() {
    this.invoiceFilterDD = [];
    if (this.Allinvoices.length == 0) {
      this.invoiceFilterDD = [{ value: 'All', label: 'All' }];
    } else {        
      const uniqueStatuses =  Array.from(new Set(this.Allinvoices.map((invoice) => invoice.status)));
      this.invoiceFilterDD = [
        { value: 'All', label: 'All' },
        ...uniqueStatuses.map((status) => ({
          value: status,
          label: status,
        })),
      ];
    }
  }

   loadMoreInvoices = async() => {
    await this.indexedDbService.storeInvoices(this.ban, this.Allinvoices, true);
    if (this.invoices.length < this.Allinvoices.length) {
      this.appendData();
    } else(this.invoices.length === this.Allinvoices.length);  {
      this.isAllInvoicesLoaded = true;  
    }
  }
  
  appendData() {
    this.invoices = [...this.Allinvoices];
    this.resetLoadMoreButton();
  }

  removeData() {
    this.toggleLoading();
    this.invoices = this.Allinvoices.slice(0, this.invoices.length - this.itemsPerPage);
  }


  public addBill(invoice: IInvoice) {
    if (!invoice.isSelected) {
      // console.log("inside if")
      //this.showbtn = (x === 1);
      this.pendingAmountToPay += +invoice.pending_amount;
      this.currency = invoice.currency;
      this.iNumber = invoice.invoice_id;
      this.payStatus.push(invoice.status);
      // console.log("after status")
      this.selectedInvoices.push(invoice);
    } else {
      this.pendingAmountToPay -= -invoice.pending_amount;
      this.currency = invoice.currency;
      this.iNumber = "";
      this.payStatus.push("");

      this.selectedInvoices.forEach((ele, index) => {
        console.log("inside for")
        if (ele.invoice_id == invoice.invoice_id) {
          this.selectedInvoices.splice(index, 1);
        }
      });

      this.payStatus.forEach((element, index) => {
        if (element == invoice.status) {
          this.payStatus.splice(index, 1);
        }
      });
    }
  }


  openPaidAlert(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
      });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }

  }

  summary(content: any, invoice: any) {
      if (this.isMakePaymentEnabled && this.permissions.includes('BI-MP')){
    for (var i = 0; i < this.payStatus.length; i++) {
      if (this.payStatus[i].toUpperCase() == 'PAID') {
        this.openPaidAlert(content);
        console.log("alert popup open", this.payStatus);
        return;
      }
    }
    if (invoice != null) {
      this.selectedInvoices = [];
      if (invoice.status.toUpperCase() == 'PAID') {
        this.openPaidAlert(content);
        console.log("alert popup open", this.payStatus);
        return;
      }
      this.currency = invoice.currency;
      this.pendingAmountToPay = invoice.pending_amount;
      this.selectedInvoices.push(invoice);
    }
    if (this.pendingAmountToPay == 0) {
      return;
    }
    this.totalEditedAmount = this.pendingAmountToPay;
    localStorage.setItem("InvoiceList", JSON.stringify(this.selectedInvoices));
    this.router.navigate(["summary"], { relativeTo: this.route });
    return;
  }else {
     this.openPaymentPermissionDeniedModal();
  }
}

  openPaymentPermissionDeniedModal(){
    const modalRef = this.modalService.open(this.paymentStatus);
    modalRef.result.then((result) => {
      console.log('Modal closed', result);
    }).catch((error) => {
      console.log('Modal dismissed', error);
    });
  }

  cancel() {
    this.router.navigate(["invoices"]);
    //location.reload();
  }

  async payBills() {
    console.log(this.selectedInvoices)
    localStorage.setItem("CreatSB", "false");
    localStorage.setItem("InvoiceList", JSON.stringify(this.selectedInvoices));
    this.router.navigate(["../checkout"], { relativeTo: this.route });

  }

  getTotalAmount() {
    this.totalEditedAmount = this.selectedInvoices.map(a => parseFloat(a.editedAmountToPay)).reduce((x, y) => x + y, 0);;
    return this.totalEditedAmount;
  }

  /**
  * Method is use to download file.
  * @param bpNo - business partner number
  * @param invoiceId - invoice number.
  * @param dueDate - due date to invoice
*/
  download(bpNo: any, invoiceId: any, dueDate: any) {
    //calling service 
   // +"_"+formatDate(dueDate,'yyyyMMdd',"en-US")
    var id = btoa(bpNo+""+invoiceId)
    this.showLoader = true;
    this.invoicesService.downloadInvoice(id).subscribe(response => {
      console.log(response.data);
      console.log(response.filename);
      console.log(response.data.byteLength);
      if (response.data.byteLength > 0) {
        var binaryData = [];
        binaryData.push(response.data);
        var url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
        this.downloadFile(url, response.filename);
        this.showLoader = false;
      } else {
        this.showLoader = false;
        this.open("Error", "Something went wrong while downloading the invoice '" + invoiceId + "', please try again or contact support team.");
      }
    }, (error: any) => {
      this.showLoader = false;
      this.open("Error", error);
    });
  }
  /**
   * Method is use to create temp anchor tag for download file.
   * @param url - url to download with Buffer data
   * @param fielName - document name.
   */
  downloadFile(url: string, fielName: string) {
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.setAttribute('target', 'blank');
    a.href = url;
    a.download = fielName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  open(status: any, message: any) {
    const modalRef = this.modalService.open(NgbdModalContent);
    if (status == "Success") {
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "block";
      modalRef.componentInstance.error = "none";
    } else {
      //modalRef.componentInstance.name =this.translate.instant("ASM.Invoices.error."+message);
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "none";
      modalRef.componentInstance.error = "block";
    }
  }

  openFileInNewTab(bpNo: any, invoiceId: any, dueDate: any){
      var id = btoa(bpNo+""+invoiceId)
      this.showLoader = true;
      this.invoicesService.downloadInvoice(id).subscribe(response => {
        console.log(response.data);
        console.log(response.filename);
        console.log(response.data.byteLength);
        if (response.data.byteLength > 0) {
          var binaryData = [];
          binaryData.push(response.data);
          var url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
          window.open(url, '_blank');
          this.showLoader = false;
        } else {
          this.showLoader = false;
          this.open("Error", "Something went wrong while opening the invoice '" + invoiceId + "', please try again or contact support team.");
        }
      }, (error: any) => {
        this.showLoader = false;
        this.open("Error", error);
      });
  }

  getPaymentHistory() {
    this.router.navigate(["payment-history"],{ relativeTo: this.route });
  }

  getDispute() {
    this.router.navigate(["view-my-dispute"],{ relativeTo: this.route });
  }

  getPaymentMethods(){
    this.router.navigate(["setting"],{ relativeTo: this.route,state:{'ban':this.ban} });    
    //this.router.navigate(["payment-methods"],{ relativeTo: this.route,state:{'ban':this.ban} });
  }

  getUsageRecords(){
    this.router.navigate(["usage-records"],{ relativeTo: this.route });
  }


   ViewInvoice(item:any){
    if (this.isViewInvoiceEnabled && this.permissions.includes('BI-VI')){
    let filteredBAN = this.bansForTSA.filter((element: any) => {
      const elementBpNo = element.bancust.toString().replace(/^0+/, '');
      const itemBpNo = item.bpNo.toString().replace(/^0+/, '');
      return (element.bancust == item.bpNo || elementBpNo == itemBpNo);
    });
    if(filteredBAN[0] && filteredBAN[0].isTSA){
      this.router.navigate([`view-tsa-invoice/${item.invoice_id}`], { relativeTo: this.route, state: { invoice: item } });
    }
    else{
      this.router.navigate([`view-invoice/${item.invoice_id}`], { relativeTo: this.route, state: { invoice: item } });
    }
  }else{
    this.openViewInvoicePermissionDeniedModal();
  }
 }

 openViewInvoicePermissionDeniedModal() {
    const modalRef = this.modalService.open(this.permissionStatus);
    modalRef.result.then((result) => {
      console.log('Modal closed', result);
    }).catch((error) => {
      console.log('Modal dismissed', error);
    });
  }

  selectBan(selectedBan: string): void {
    this.ban = selectedBan;
    this.invoiceFilterValue = 'All';
    this.invoicesSearch = '';
    this.isMasterSel = false;
    this.checkUncheckAll();
    if (this.ban != "BAN") {
      const selectedBan = this.banCAs.get(this.ban) || [""];
      var sledBan =  this.banResponse.find((x: { bancust: string; }) => x.bancust ==  this.ban)||{zzachclass_bus:""};
      this.getInvoices(this.ban, selectedBan,sledBan.zzachclass_bus == 'SLED'?true:false);
    }
  }

  resetLoadMoreButton() {
    console.log(this.invoices.length, this.Allinvoices.length);
    if (this.invoices.length === this.Allinvoices.length) {
          this.isAllInvoicesLoaded = true;
    }else{
      this.isAllInvoicesLoaded = false;
    }
  }

  downloadCSV() {
    if (this.Allinvoices.length) {
      let data = this.makeCSV(this.Allinvoices);
      this.fileDownload(data);
    }
  }

  fileDownload(data: any) {
    const fileName = `${this.ban}-Invoice-List.csv`;
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', fileName);
    a.click();
  }

  makeCSV(data: any[]) {
    type Invoice = {
      invoice_id?: any;
      date?: any;
      caContract?: any;
      amount?: any;
      currency?: any;
      status?: any;
      dueDate?: any;
      pending_amount?: any;
      invoiceReversalDocumentID?: any;
      invoiceReversedDocumentID?: any;
      bpNo?: any;
      businessPartnerName?: any;
      isSledCustomer?: any;
      [key: string]: any;
    };
  
    const columnNameMapping: { [key: string]: string } = {
      invoice_id: 'Invoice No.',
      date: 'Invoice Date',
      caContract: 'Contract Account',
      amount: 'Invoice Amount',
      currency: 'Currency',
      status: 'Invoice Status',
      pending_amount: 'Pending Amount',
      invoiceReversalDocumentID: 'Invoice Reversal ID',
      invoiceReversedDocumentID: 'Invoice Reversed ID',
      bpNo: 'Billing Account No.',
      businessPartnerName: 'Business Partner Name',
      isSledCustomer: 'Is Sled Customer',
    };
  
    const filteredData = data.map((item: Invoice) => {
      const { 
        invoice_id, date, caContract, amount, currency, status, dueDate, pending_amount, invoiceReversalDocumentID, invoiceReversedDocumentID, bpNo, businessPartnerName, isSledCustomer, 
        ...rest 
      } = item;
      const mappedItem: any = {
        [columnNameMapping['invoice_id']]: invoice_id,
        [columnNameMapping['date']]: date,
        [columnNameMapping['caContract']]: caContract,
        [columnNameMapping['amount']]: amount,
        [columnNameMapping['currency']]: currency,
        [columnNameMapping['status']]: status,
        [columnNameMapping['pending_amount']]: pending_amount,
        [columnNameMapping['invoiceReversalDocumentID']]: invoiceReversalDocumentID,
        [columnNameMapping['invoiceReversedDocumentID']]: invoiceReversedDocumentID,
        [columnNameMapping['bpNo']]: bpNo,
        [columnNameMapping['businessPartnerName']]: businessPartnerName,
        [columnNameMapping['isSledCustomer']]: isSledCustomer,
      };
      return mappedItem;
    });
    const headers = Object.keys(filteredData[0]);
    const csvContent = [];
    csvContent.push(headers.join(','));
  
    filteredData.forEach((item: any) => {
      const row: any = [];
      headers.forEach(header => {
        let value = item[header];
        value = value !== undefined && value !== null ? value.toString() : '';
        if (typeof value === 'string' && value.includes(',')) {
          value = `"${value}"`;
        }
        row.push(value);
      });
      csvContent.push(row.join(','));
    });
    return csvContent.join('\n');
  }

  get getInvoicesList() {
    let filteredInvoices = this.invoices;
    let unPaidInvoices : any = this.Allinvoices.length && this.Allinvoices.filter(invoice => {
      return invoice.pending_amount > 0;
    })
    if(unPaidInvoices.length>0){
      this.isAllInvoicesPaid = false
    }
    else{
      this.isAllInvoicesPaid = true;
    }
    if (this.invoiceFilterValue && this.invoiceFilterValue!='All') {
        filteredInvoices = filteredInvoices.filter(invoice => 
            invoice.status === this.invoiceFilterValue
        );
    }
    if (this.invoicesSearch) {
        filteredInvoices = filteredInvoices.filter(invoice => 
            invoice.invoice_id.toLowerCase().includes(this.invoicesSearch.toLowerCase())
        );
    }
    if(this.invoicesSearch || this.invoiceFilterValue){
      if((filteredInvoices.length < this.itemsPerPage) || (this.invoices.length === this.Allinvoices.length)){
        this.isAllInvoicesLoaded = true;
      }
      else{
        this.isAllInvoicesLoaded = false;
      }
    }
    return filteredInvoices;
  }

  filterInvoiceList(event: any) {
      this.invoiceFilterValue = event.value;
      this.selectedInvoices = [];
      this.isMasterSel = false;
      this.checkUncheckAll();
  }

  /* Code for loading Billing Analytics */
  newUrl:any;
  isBillAnalyticsEnabled: boolean = environment.billAnalyticsEnableFlag;

  openNewTab(newUrl:any){
    var url = "https://api-dv.brightspeed.com/bp-aci/globys/sso-url"

    var data ={
      "userLogin": newUrl,
      "langCode": "eng",
      "tokenExpirationSeconds": 3000,
      "useToken": true
    }

    this.http.post(url,data).subscribe((res:any)=>{
      console.log(res)
      this.modalService.dismissAll();
      window.open(res.href, '_blank');
    })

  }

  openBillAnalytics(content: any) { 
    this.modalService.open(content, 
   {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => { 
      this.closeResult = `Closed with: ${result}`; 
    }, (reason) => { 
      this.closeResult =  
         `Dismissed ${this.getDismissReason(reason)}`; 
    }); 
  } 

  showErrorScreen(){
    this.invoices = [];
    this.Allinvoices = [];
    this.unSupportedBanInvoices = true;
    this.errorPopup && this.errorPopup.showPopup();
  }
  
  disputeBAN(){
    let caNumbers : any= this.banCAs.get(this.ban);
    let banData = {
      bpNo: this.ban,
      caContract: caNumbers[0],
      currency: this.currency || "USD",
      invoice_id: ''
    }
    localStorage.setItem('dispute-type', 'ban-level-dispute')
    localStorage.setItem('ban-data-to-dispute', JSON.stringify(banData))
    this.router.navigate(['/invoices/create-dispute'], { state: { banData: banData } });
  }

  getFormattedValue(value: any): number {
    if (value.endsWith('-')) {
      return parseFloat(value.replace('-', '')) * -1;
    }
    return parseFloat(value);
  }

  toggleFilterSection(){
    this.filterSectiontoggle = !this.filterSectiontoggle;
  }
}
